// Imports => React
import React, {useMemo, memo} from 'react';
import {Props} from './ac-grid-row.proptypes';
import clsx from 'clsx';

const _CLASSES = {
  MAIN: 'ac-row',
  NOGUTTERS: 'ac-row--no-gutters',
  FORM: 'ac-row--form',
};

// Component
const AcRow = memo(({rel = 'ac-row', className, noGutters, form, children, ...rest}) => {
  const getStyleClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, noGutters && _CLASSES.NOGUTTERS, form && _CLASSES.FORM, className);
  }, [noGutters, form, className]);

  return (
    <div className={getStyleClassNames} rel={rel} {...rest}>
      {children}
    </div>
  );
});

AcRow.displayName = 'AcRow';
AcRow.propTypes = Props;

export {AcRow};
